import { useContext } from "react";
import { RecaptchaV3Context } from "@/components/RecaptchaV3";

export function useRecaptchaV3() {
  return useContext(RecaptchaV3Context);
}
